"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require('./../scss/sites/pommac/pommac.scss');
const index_1 = require("./../js/index");
const pommac_1 = require("./../js/Sites/pommac");
// Initialize scripts that are used in all websites
(0, index_1.Init)();
// Initialize TastingDays2021 specific scripts
(0, pommac_1.InitPommac)();
// Import styles and scripts included in coreweb packages
(0, index_1.ImportCoreweb)();
// Initialize and mount react components
(0, index_1.InitReact)();
